export default {
  formConfig: {
    formValue: {
      startEndTimes: [],
      bill_no: '',
    },
    formData: [
      {
        style: 'dropSelect', // 输入框弹框单多选
        width: '24',
        inputList: [],
        isActive: true,
        isdisabled: false,
        inputList: [
          {
            childs: [{ colname: 'CP_C_SHOP_ID', refobjid: 57, valuedata: 2 }],
          },
        ],
        itemdata: {
          colid: 167606,
          colname: 'CP_C_SHOP_ID', // 当前字段的名称
          refcolval: {
            fixcolumn: 'CP_C_PLATFORM_ID',
            expre: 'equal',
            srccol: 'CP_C_SHOP_ID',
          },
          fkdisplay: 'drp', // 外键关联类型
          isfk: true, // 是否有fk键
          isnotnull: true, // 是否必填
          serviceId: 'r3-cp',
          name: $it('other.shop'), // 店铺 input前面显示的lable值
          readonly: false, // 是否可编辑，对应input   readonly属性
          pid: '',
          valuedata: '', // 这个是选择的值
        },
        oneObj: () => {},
      },
      {
        style: 'date', // 输入框类型
        label: '账单日期',
        colname: 'startEndTimes',
        type: 'datetimerange',
        value: 'startEndTimes', // 输入框的值
        width: '24', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
        format: 'yyyy-MM-dd HH:mm:ss',
        onChange: () => {},
      },
      {
        style: 'input', // 输入框类型
        label: $it('fL.platform_billNo'), // 平台单号
        value: 'bill_no', // 输入框的值
        width: '24', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
        ghost: false, // 是否关闭幽灵按钮，默认开启
        inputenter: () => {}, // 表单回车事件
      },
    ],
    ruleValidate: {
      CP_C_SHOP_ID: [
        {
          required: true,
          message: ' ',
        },
      ],
    },
  },
  init: (self) => {
    $utils.formEmpty(self, 'downLoadFormConfig');
  },
  // 确定按钮
  determine: async (self) => {
    const formValue = self.downLoadFormConfig.formValue;
    if (!self.downLoadFormConfig.formData[0].itemdata.pid) {
      self.$Message.warning($it('tip.be')); // 请选择需要下载的店铺
      return false;
    }
    const [start, end] = formValue.startEndTimes;
    if (!start && !formValue.bill_no) {
      self.$Message.warning('账单日期和平台单号必须任选其一！');
      return false;
    }
    if (start && formValue.bill_no) {
      self.$Message.warning('账单日期和平台单号只能任选其一！');
      return false;
    }
    const param = {
      cp_c_shop_id: self.downLoadFormConfig.formData[0].itemdata.pid,
      bill_no: formValue.bill_no, // 平台单号
      start_time: start ? $utils.standardTimeConversiondateToStr(start) : '',
      end_time: end ? $utils.standardTimeConversiondateToStr(end) : '',
      table: self.$route.params.tableName, // 当前表名
    };
    self.dialogLoad = true;
    self.service.interfacePlatform
      .douyinBillDownload(param)
      .then((res) => {
        const {
          data: { code, message },
        } = res.data;
        if (code === 0) {
          self.dialogLoad = false;
          self.$Message.success(message);
          self.$emit('confirmImport');
          self.$emit('closeActionDialog', true);
        } else {
          $fcError(message);
        }
      })
      .finally((e) => {
        self.dialogLoad = false;
      });
  },
};
